module.exports = __webpack_public_path__ + "img/tele-training.0b16c68e.svg";